let BodyIndex = {};

BodyIndex['body-lazy'] = require('./Body/body').default;
BodyIndex['body-nolazy'] = require('./Body/body-nolazy').default;

export default BodyIndex


// WEBPACK FOOTER //
// ./src/components/DataTable/BodyIndex.js